import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { event: String, context: String }

  track() {
    try {
      const name = this.eventValue || this.element.dataset.mpEvent || "UI Action";
      const ctx = this.contextValue ? JSON.parse(this.contextValue) : (this.element.dataset.mpContext ? JSON.parse(this.element.dataset.mpContext) : {});
      if (window.Mixpanel) {
        window.Mixpanel.custom(name, ctx || {});
      }
    } catch (e) {
      // swallow errors in dev
    }
  }
}


